<script lang="ts" setup>
const t2 = useT2({
  'Notify Me': 'Pranešimai',
  'Back in Stock': 'Prekė prekyboje',
  'Lower Price': 'Sumažėjusi kaina',
})

defineProps<{
  inStock: boolean
  productPrice: number
  productId: string
}>()

const init3 = useInited('init3')
const mobile = useMobile()
const auth = useAuth()
const notify = useNotify()
const open = shallowRef(false)
const timer = useTimeout()
</script>

<template>
  <ButtonIcon v-if="mobile" :ref="notify.elem" :txt="t2('Notify Me')" aria-label="Notify" class="_b5 _c2" size="50" @click.passive="open = !open">
    <span class="_svg20">
      <LazyIconBell v-if="init3" class="_svg20" />
    </span>
  </ButtonIcon>

  <ButtonAction v-else :ref="notify.elem" color="whiteFull" big :txt="undefined" :submit="() => (open = !open)">
    <span class="_svg20">
      <LazyIconBell v-if="init3" class="_svg20" />
    </span>
    <ButtonTxt right :label="t2('Notify Me')" :sub="inStock ? t2('Lower Price') : t2('Back in Stock')" fw="_fw-l" />
  </ButtonAction>

  <UiNotify :notify />

  <UiPreview4 v-model="open" :elem="() => notify.elem.value" nopad :dropdown="mobile" :class-modal="$style.m2" :class-top="$style.m1">
    <LazyAuthOpen v-if="!auth.isAuth" :on-auth="() => timer.set(() => (open = true), 100)" />
    <LazyBuyerNotifyModal v-else :product-id :notify :product-price :in-stock />
  </UiPreview4>
</template>

<style module>
.m2 {
  composes: global(d_pt1);
  composes: global(d_pb2);
  composes: global(d_br22);
}
:global(.d) .m1 .m2 {
  width: 360px;
  border-radius: 22px;
}
</style>
